import { addModifiers } from '../../shared/helpers';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';
import Parser from 'html-react-parser';
import * as React from 'react';

export interface TutorialTaskProps {
  task: string;
  isComplete?: boolean;
}

export function TutorialTask({ task, isComplete }: TutorialTaskProps) {
  const headerId = isComplete ? 'navigatorTutorial.completeTaskTitle' : 'navigatorTutorial.taskTitle';
  const modifiers = isComplete ? ['complete'] : [];

  return (
    <div className={addModifiers('tutorial-task', modifiers)}>
      <FormattedMessageHelper tagName={'strong'} id={headerId} />
      {Parser(task)}
    </div>
  );
}
